import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';

import { guid } from '@firestitch/common';
import { FsMessage } from '@firestitch/message';

import { Subject, zip } from 'rxjs';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';

import { AclRoleReferences } from '@app/common';
import { Account, Environment } from '@app/common/interfaces';
import { EnvironmentData } from '@app/core/data';
import { AuthService, SessionService } from '@app/core/services';

import { EnvironmentCreate } from '../../interfaces';


@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InviteComponent implements OnInit, OnDestroy {

  @Input() public environmentCreate: EnvironmentCreate = null;

  @Output() public completed = new EventEmitter();
  @Output() public cancel = new EventEmitter();

  public aclRoleReferences = AclRoleReferences;

  public account: Account = null;

  private _destroy$ = new Subject();

  constructor(
    private _cd: ChangeDetectorRef,
    private _router: Router,
    private _environmentData: EnvironmentData,
    private _authService: AuthService,
    private _sessionService: SessionService,
    private _message: FsMessage,
  ) { }

  public ngOnInit(): void {
    this.account = this._sessionService.account();
    this.memberAdd(3);
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public focus(index: number): void {
    if (index === (this.environmentCreate.members.length - 1)) {
      this.memberAdd();
    }
  }

  public memberAdd(count: number = 1): void {
    for (let i = 0; i < count; i++) {
      this.environmentCreate.members.push({
        email: null,
        // aclRoleReference: AclRoleReference.EnvironmentAdmin,
        guid: guid(),
      });
    }

    this._cd.detectChanges();
  }

  public save = () => {
    return this._environmentData.post(this.environmentCreate)
      .pipe(
        switchMap((environment: Environment) => {
          return zip(
            this._authService.reloadPermissions(),
            this._environmentData.switch(this.account.id, environment.id),
          )
            .pipe(
              map(() => {
                this._sessionService.environment(environment);

                return environment;
              }),
              takeUntil(this._destroy$),
            );
        }),
        tap((environment: Environment) => {
          this._message.success('Saved Changes');
          this.completed.emit();
          this._router.navigate(['/dashboard']);
        }),
      );
  };

}
